import { render } from "./AnnouncementReport.vue?vue&type=template&id=1385096f"
import script from "./AnnouncementReport.vue?vue&type=script&lang=js"
export * from "./AnnouncementReport.vue?vue&type=script&lang=js"
script.render = render

export default script